module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.connects,
      "hideFooter": true
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Check")])], 1), _vm._v(" "), _c('div', {
    staticClass: "check",
    slot: "content"
  }, [_c('div', {
    staticClass: "b-b b-t"
  }, [_c('translate', [_vm._v("Connection Information")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vertify-content"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Name")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.name || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.name),
      expression: "connects.name",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.type || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.type),
      expression: "connects.type",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Address")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.ip || '-'))]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.connects.ip),
      expression: "connects.ip",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('a', [_c('translate', [_vm._v("Copy")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Port")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(" " + _vm._s(_vm.connects.port || '-') + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Code")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.hideStr(_vm.contact.code) || '-'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Username")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_vm._v(_vm._s(_vm.connects.login_user ? _vm.connects.login_user[0] : '-'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 8
    }
  }, [_c('translate', [_vm._v("Report Type")]), _c('span', [_vm._v(":")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.connectInfo.type),
      callback: function($$v) {
        _vm.connectInfo.type = $$v
      },
      expression: "connectInfo.type"
    }
  }, _vm._l((_vm.reportTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 8,
      "span": 16
    }
  }, [(_vm.o.os == 'mysql') ? _c('div', {
    staticClass: "tips"
  }, [_c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("Diagnostic connection users must have the following rights")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("grant select on information_schema.* to 'select'@'%';")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("grant process on *.* to 'select'@'%';")])], 1) : _vm._e(), _vm._v(" "), (_vm.o.os == 'mssql') ? _c('div', {
    staticClass: "tips"
  }, [_c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("A diagnostic connection user must have at least one of the following role permissions for the diagnostic database")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("- db_owner")]), _vm._v(" "), _c('translate', {
    staticClass: "text-center",
    attrs: {
      "tag": "h4"
    }
  }, [_vm._v("- sysadmin")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 8
    }
  }, [(!_vm.btnLoading) ? _c('el-button', {
    staticClass: "w-full m-t",
    attrs: {
      "disabled": !_vm.connectInfo.type
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sendCheck($event)
      }
    }
  }, [_vm._v("发起诊断")]) : _vm._e(), _vm._v(" "), (_vm.btnLoading) ? _c('el-button', {
    staticClass: "w-full m-t",
    attrs: {
      "loading": _vm.btnLoading,
      "disabled": ""
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "b-t m-t"
  }, [_c('translate', [_vm._v("Diagnostic Report List")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.m
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.reportname
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name || '-') + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.hostname,
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.connects.name) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.checktime,
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("moment")(scope.row.data_create_time, 'YYYY-MM-DD HH:mm:ss')) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tasks_status !== 'working') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.view(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("View")])], 1) : _vm._e(), _vm._v(" "), (scope.row.tasks_status === 'working') ? _c('el-button', {
          attrs: {
            "type": "text",
            "loading": ""
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pageList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.pageList.totalPage,
      "page-size": 10,
      "current-page": _vm.pageList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.pageList.currentPage = $event
      },
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3a48ace"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/check.vue
// module id = 618
// module chunks = 4 5 6